import React, { useMemo, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTable, useSortBy, usePagination } from "react-table";
import TableHeaders from "./TableHeaders";
import TableBody from "./TableBody";
import TableControls from "./TableControls";
import { getShortDateTime, getShortAddresName } from "../utils/formatter";
import { Tooltip } from 'react-tooltip'
import OverTableButtons from "../components/OverTableButtons";
import PlainContainer from "../components/PlainContainer";
import TableSearch from "../components/TableSearch";
import { SEARCH_DEBOUNCE_TIME } from "../utils/constants";
import { debounce } from "../utils/debounce";
import Button from "./Button";
import getAudioBooksLinkId from "../api/getAudioBooksLinkId";
import { enqueueSnackbar } from "notistack";
//let users = require("../mock/mock_audiobooks_view.json");

const col = [
  {
    Header: "Data",
    accessor: "date",
    columnType: "col-sm-1",
    Cell: ({ value }) => {
      const { date, time } = getShortDateTime(value);
      const formattedTime = time.split(':').slice(0, 2).join(':');
      return <span
        data-tooltip-id="timedate-tooltip"
        data-tooltip-content={time}
      >
        {date} {formattedTime}
        <Tooltip id="timedate-tooltip" />
      </span>
    },
  },
  {
    Header: "Symbol",
    accessor: "symbol",
    columnType: "col-sm-1",
  },
  {
    Header: "Tytuł",
    accessor: "title",
    columnType: "col-sm-4",
  },
  {
    Header: "Nabywca",
    accessor: "purchaser",
    columnType: "col-sm-2",
    Cell: ({ value, row }) => {
      let toolTip = value;
      value = getShortAddresName(value);

      return (
        <span
          data-tooltip-id={toolTip ? "from-tooltip" : undefined}
          data-tooltip-content={toolTip}
        >
          {value}
          {toolTip && <Tooltip id="from-tooltip" />}
        </span>
      );
    }
  },
  {
    Header: "Ilość",
    accessor: "amount",
    columnType: "col-sm-1",
  }, {
    Header: "Cena",
    accessor: "price",
    columnType: "col-sm-1",
  },
  {
    Header: "Nr zamówienia",
    accessor: "orderNo",
    columnType: "col-sm-2",
  },
];

const SalesTable = ({ data, customStyles, loggedUser }) => {
  const columns = useMemo(() => col, []);
  const [searchInput, setSearchInput] = useState("");
  const [filteredData, setFiltered] = useState(data || []);

  const tableData = useMemo(() => filteredData, [filteredData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    state,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    prepareRow,
    gotoPage,
    pageCount,
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageSize: 14 },
      autoResetSortBy: false
    },
    useSortBy,
    usePagination,
  );
  const { pageIndex } = state;

  const handleChange = (event) => {
    setSearchInput(event.target.value);
  };

  useEffect(() => {

    const filterTransactions = () => {
      if (searchInput.length > 2) {
        let pattern = searchInput.toLocaleLowerCase();
        let results = data.filter((value) => {
          if (
            value !== undefined
          ) {
            return (
              value.symbol.toLowerCase().includes(pattern) ||
              value.title.toLowerCase().includes(pattern) ||
              value.purchaser.toLowerCase().includes(pattern)
            );
          } else {
            return null;
          }
        });
        setFiltered(results);
      } else {
        setFiltered(data);
      }
    };
    debounce(filterTransactions, SEARCH_DEBOUNCE_TIME)();
  }, [searchInput, data]);


  return (
    <div
      style={{ ...customStyles, }}>
      <OverTableButtons
        widthInVw={95}
        heightInVh={4.1}
        customStyles={{ top: "15.5vh" }}
      >
        <TableSearch
          name="searchInputField"
          data={searchInput || ""}
          onChange={handleChange}
        />
        <Button
          text="Zamówienia"
          styleOptions={{
            display: "inline",
            padding: "0.25rem 0.5rem",
            marginLeft: "1rem",
            minWidth: "100px"
          }}
          isDisabled={false}
          onClick={async () => await ordersLink(loggedUser)}
        />

      </OverTableButtons>
      <div>
        <PlainContainer
          widthInVw={95}
          customStyles={{
            top: "19vh",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            paddingBottom: "0px",
          }}
        >
          <div
            className="container"
            {...getTableProps()}
            style={{ maxWidth: "100%", maxHeight: "55vh" }}
          >
            {
              <>
                <TableHeaders headerGroups={headerGroups} />
                <TableBody
                  {...getTableBodyProps()}
                  rows={page}
                  prepareRow={prepareRow}
                />
                <TableControls
                  pageOptions={pageOptions}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  canNextPage={canNextPage}
                  canPreviousPage={canPreviousPage}
                  pageIndex={pageIndex}
                  gotoPage={gotoPage}
                  pageCount={pageCount}
                />
              </>
            }
          </div>
        </PlainContainer>
      </div>
    </div>
  );
};

export default withRouter(SalesTable);

export async function ordersLink(loggedUser) {
  // open new website 
  try {
    const data = await getAudioBooksLinkId({
      address: loggedUser.libAddress,
      jwtToken: loggedUser.jwtToken,
    });
    window.open('https://shoppro.audiobook.pl?linkId=' + data);
  } catch (error) {
    if (error.message === "Invalid or missing JWT token") {
      enqueueSnackbar("Sesja wygasła. Wyloguj się i zaloguj ponownie", { variant: "error" });
    } else {
      enqueueSnackbar(`Błąd: ${error.message}`, { variant: "error" });
    }
  }
}
